import axios from "axios";

import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Container,
  Switch,
  FormControlLabel,
  CircularProgress,
  Divider,
  Card,
  CardContent,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

import { useNavigate } from "react-router-dom";
// Import your existing callApi function - make sure this path is correct
import { callApi } from "./api";

const RagTestComponent = () => {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [useRag, setUseRag] = useState(true);
  const messagesEndRef = useRef(null);

  const navigate = useNavigate();

  // Add this effect at the top of your existing useEffect blocks
  useEffect(() => {
    // Check if user is not admin and redirect
    if (!user.admin) {
      navigate("/");
    }
  }, [navigate]);

  // Scroll to bottom when messages change
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!input.trim()) return;

    // Add user message to chat
    const newMessage = { role: "user", content: input };
    setMessages((prevMessages) => [...prevMessages, newMessage]);
    setInput("");
    setIsLoading(true);

    try {
      // Define API_URL first before using it
      const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

      console.log(
        "Attempting to connect to API:",
        useRag ? `${API_URL}/api/openai-rag` : `${API_URL}/api/openai`,
      );

      const allMessages = [...messages, newMessage];

      // Make the API call directly to avoid any function import issues
      const response = await axios.post(
        useRag ? `${API_URL}/api/openai-rag` : `${API_URL}/api/openai`,
        {
          messages: allMessages,
          maxTokens: 2000,
          temperature: 0.7,
        },
      );

      console.log("API response received:", response);

      const responseContent = response.data.choices[0].message.content;

      // Add assistant response
      setMessages((prevMessages) => [
        ...prevMessages,
        { role: "assistant", content: responseContent },
      ]);
    } catch (error) {
      // Enhanced error logging
      console.error("Detailed error:", {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        config: error.config,
      });

      setMessages((prevMessages) => [
        ...prevMessages,
        {
          role: "assistant",
          content:
            "Det uppstod ett fel vid behandling av din fråga. Vänligen försök igen.",
          isError: true,
        },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 3, my: 4 }}>
        <Typography variant="h4" gutterBottom>
          RAG Test Interface
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={useRag}
              onChange={() => setUseRag((prev) => !prev)}
              color="primary"
            />
          }
          label={
            useRag ? "Using RAG (Retrieval)" : "Standard API (No Retrieval)"
          }
        />
        <Divider sx={{ my: 2 }} />

        <Box
          sx={{
            height: "400px",
            overflowY: "auto",
            mb: 2,
            p: 2,
            bgcolor: "#f5f5f5",
          }}
        >
          {messages.map((msg, index) => (
            <Card
              key={index}
              sx={{
                mb: 2,
                ml: msg.role === "assistant" ? 0 : "auto",
                mr: msg.role === "user" ? 0 : "auto",
                maxWidth: "80%",
                bgcolor: msg.role === "user" ? "#e3f2fd" : "white",
              }}
            >
              <CardContent>
                <Typography
                  variant="body1"
                  sx={{
                    whiteSpace: "pre-wrap",
                    color: msg.isError ? "error.main" : "inherit",
                  }}
                >
                  {msg.content}
                </Typography>
              </CardContent>
            </Card>
          ))}
          <div ref={messagesEndRef} />
        </Box>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Ställ en fråga om ditt indexerade innehåll..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            disabled={isLoading}
            sx={{ mr: 1 }}
          />
          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={isLoading || !input.trim()}
            endIcon={
              isLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <SendIcon />
              )
            }
          >
            Skicka
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default RagTestComponent;
